module.exports = __webpack_public_path__ + "static/icons/icon-snow-history--white-c6fd0f2e167e059dd45e39d3f6408fa1.svg";